var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("캠페인 후원")])]), _c('campaign-tabs'), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": "",
      "to": "/news/campaign/one-meal"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/campaign/one-meal/thumb.webp"
    }
  }), _c('v-card-title', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v("결식우려아동 식사 공백 줄이기 캠페인")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": "",
      "to": "/news/campaign/infant"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/campaign/infant/thumb.jpg"
    }
  }), _c('v-card-title', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v("위기영아지원 캠페인")])], 1)], 1)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }